// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.client.phoneverifier.enums.PhoneVerificationType

export enum PhoneVerificationType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  SMS = 'SMS',
}

export const PhoneVerificationType_values = [
  PhoneVerificationType.EMAIL,
  PhoneVerificationType.PHONE,
  PhoneVerificationType.SMS,
] as const;
